import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxOtpInputConfig } from 'ngx-otp-input';
import * as alerts from '../../_functions/alerts';
import { Membro, StatusMembro } from '../../_models/membro';
import {
  MessageRequetModel,
  SmsRequestModel,
} from '../../_models/smsRequestModel';
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';

@Component({
  selector: 'app-valida-dados',
  templateUrl: './validadados.component.html',
  styleUrls: ['./validadados.component.scss'],
  providers: [],
})
export class ValidaDadosComponent implements OnInit {
  membroForm: UntypedFormGroup;

  membro: Membro = new Membro();

  public idadeMembro: number = 0;

  public exibirDataVazio: boolean = false;

  salvandoMembro: boolean = false;

  exibirPopupTerminoContaOne: boolean = false;
  exibirModalComunicacao: boolean = false;
  exibirPopupGenerico: boolean = false;
  exibirModalValidacaoDados: boolean = false;
  exibirBotaoReenviar: boolean = true;

  tituloModalGenerico: string = '';
  descricaoModalGenerico: string = '';
  descricaoBotaoModalGenerico: string = '';
  descricaoSegundosModalValidacaoDados: string = '';
  mensagensErros: string[] = [];
  telefone: string = '';
  email: string = '';

  menorQueDataLimite: boolean = false;
  idade: number = 0;

  // ** int ** //
  tamanhoInputValidacao: Array<number> = [1, 2, 3, 4, 5, 6];
  time: number = 0;
  interval: any;

  otpInputConfig: NgxOtpInputConfig = {
    otpLength: 6,
    autofocus: true,
    classList: {
      container: 'container__otps',
      inputBox: 'number__container',
      input: 'input__otp',
      inputFilled: 'my-super-filled-class',
      inputDisabled: 'my-super-disable-class',
      inputSuccess: 'my-super-success-class',
      inputError: 'my-super-error-class',
    },
  };

  readonly CAMPO_TELEFONE: string = 'telefone';
  readonly CAMPO_EMAIL: string = 'email';

  confirmaExclusao: boolean = false;

  dadosvalidados: boolean = false;

  constructor(
    private fidelidadeService: FidelidadeService,
    private datepipe: DatePipe,
    private authService: AuthService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private el: ElementRef
  ) {
    this.registrarForm();
  }

  ngOnInit(): void {
    this.obterMembro();
  }

  private registrarForm() {
    this.membroForm = this.fb.group({
      dataNascimento: [''],
      telefone: ['', [Validators.required, Validators.minLength(11)]],
      email: ['', []],
    });
  }

  dataNascimentoValidator(control) {
    // const dataNascimento = new Date(control.value);
    // const dataLimite = new Date('1753-01-01');

    const nascimento: string = this.converterData(control.value);
    const ano = Number(nascimento.substring(4, 8));

    const idade = new Date().getFullYear() - ano;

    if (idade > 120) {
      this.menorQueDataLimite = true;
      return { dataInvalida: true };
    }

    return null;
  }

  private obterMembro() {
    this.fidelidadeService.obterMembro().subscribe(
      (sucesso) => {
        this.processarSucessoObterMembro(sucesso);
      },
      (falha) => {
        this.processarFalhaObterMembro(falha);
      }
    );
  }

  public converterData(data: Date): string {
    return this.datepipe.transform(data, 'dd/MM/yyyy');
  }

  public converterDataPreencher(data: Date, format: string) {
    return this.datepipe.transform(data, format);
  }

  // ** METODOS PRIVADOS DE SUCESSO OU INSUCESSO **//
  private processarSucessoObterMembro(response: Membro) {
    if (response.telefone) response.telefone = response.telefone.substring(2);

    if (response.tipoStatus == StatusMembro.DADOS_INVALIDOS) {
      this.membro = response;
      return;
    }
    this.membroForm.value.dataNascimento = response.dataNascimento;
    this.membroForm.value.telefone = response.telefone;
    this.membroForm.value.email = response.email;

    this.membro = response;
    this.preencherForm();

    const nascimento: string = this.converterData(this.membro.dataNascimento);
    const ano = Number(nascimento.substring(6, 10));

    this.idade = new Date().getFullYear() - ano;

    if (this.idade > 120) {
      this.menorQueDataLimite = true;
      return { dataInvalida: true };
    }
  }

  private processarFalhaObterMembro(err: any) {
    console.error(err);
  }

  private preencherForm() {
    const dataNascimentoMinima = new Date(1753, 0, 1, 0, 0, 0);

    const nascimento: any = this.membro.dataNascimento;
    const ano = Number(nascimento.substring(0, 4));
    const mes = Number(nascimento.substring(5, 7));
    const dia = Number(nascimento.substring(8, 10));

    var dataFinal = `${ano}/${mes}/${dia}`;

    const nascimentoDate: Date = new Date(dataFinal);
    if (dataNascimentoMinima.toISOString() == nascimentoDate.toISOString())
      this.exibirDataVazio == true;

    this.membroForm.patchValue({
      dataNascimento: this.exibirDataVazio
        ? '--/--/--'
        : this.converterDataPreencher(this.membro.dataNascimento, 'ddMMyyyy'),
      telefone: this.membro.telefone,
      email: this.membro.email,
    });
  }

  private dispararSms() {
    this.fidelidadeService
      .enviarSmsValidarCampoComIdMembro(
        this.obterSmsRequestModel(),
        this.membro.id
      )
      .subscribe(
        (sucesso) => {
          this.processarSucessoEnvioSms(sucesso);
        },
        (falha) => {
          this.processarFalhaEnvioSms(falha);
        }
      );
  }

  private validarEmailOuTelefoneDisponivel(campoValidacao: string) {
    const membroModel: Membro = this.membro;
    membroModel.id = this.membro.id;
    membroModel.cpf = this.membro.cpf;
    membroModel.telefone = '55' + this.membroForm.value.telefone;
    membroModel.email = this.membroForm.value.email;

    this.fidelidadeService
      .validarEmailOuTelefoneDisponivel(membroModel, campoValidacao)
      .subscribe(
        (sucesso) => {
          this.processarSucessoValidarEmailOuTelefoneDisponivel(
            sucesso,
            campoValidacao
          );
        },
        (falha) => {
          this.processarFalhaValidarEmailOuTelefoneDisponivel(
            falha,
            campoValidacao
          );
        }
      );
  }

  private processarSucessoValidarEmailOuTelefoneDisponivel(
    res: boolean,
    campoValidacao: string
  ) {
    if (res == true) {
      this.tituloModalGenerico = campoValidacao;
      this.descricaoModalGenerico = '';
      this.setarVisibilidadeModalValidacaoDados(true);

      if (campoValidacao == this.CAMPO_TELEFONE) {
        this.dispararSms();
      } else if (campoValidacao == this.CAMPO_EMAIL) {
        this.dispararEmail();
      }
    } else {
      this.tituloModalGenerico = 'Atenção :(';
      this.descricaoModalGenerico = `O ${campoValidacao} não é permitido!`;
      this.descricaoBotaoModalGenerico = 'Fechar';

      this.exibirPopupGenerico = true;
      this.salvandoMembro = false;
    }
  }

  private processarFalhaValidarEmailOuTelefoneDisponivel(
    falha: any,
    campoValidacao: string
  ) {
    this.tituloModalGenerico = 'Atenção :(';
    this.descricaoModalGenerico = `O ${campoValidacao} não é válido!`;
    this.descricaoBotaoModalGenerico = 'Fechar';

    this.exibirPopupGenerico = true;
    this.salvandoMembro = false;
  }

  private dispararEmail() {
    this.fidelidadeService
      .enviarEmailValidarCampoComIdMembro(
        this.membroForm.value.email.toString(),
        this.membro.id
      )
      .subscribe(
        (sucesso) => {
          this.processarSucessoEnvioEmail(sucesso);
        },
        (falha) => {
          this.processarFalhaEnvioEmail(falha);
        }
      );
  }

  adicionarZero(numero: number): string {
    return numero < 10 ? `0${numero}` : `${numero}`;
  }

  private validarSms(pinCode: string) {
    this.fidelidadeService
      .validarPinCodeSmsValidarCampo(this.obterSmsRequestModel(), pinCode)
      .subscribe(
        (sucesso) => {
          if (sucesso.resultado == true) {
            this.fidelidadeService.obterMembro().subscribe(
              (sucesso: Membro) => {
                sucesso.telefoneValidado = true;
                sucesso.telefone = '55' + this.membroForm.value.telefone;
                sucesso.senha = null;

                this.fidelidadeService
                  .atualizarMembroValidaDados(
                    sucesso,
                    sucesso.email ?? sucesso.cpf
                  )
                  .subscribe(
                    (sucesso) => {
                      this.setarVisibilidadeModalValidacaoDados(false);
                      this.authService.LocalStorage.salvarMembro(sucesso);
                      this.processarSucessoAtualizarMembro(sucesso);
                    },
                    (falha) => {
                      this.processarFalhaAtualizarMembro(falha);
                    }
                  );
              },
              (falha) => {
                this.processarFalhaObterMembro(falha);
              }
            );
          } else {
            alerts.exibirToast('error', 'Código informado inválido!');
            return;
          }
        },
        (falha) => {}
      );
  }

  private validarEmail(pinCode: string) {
    this.fidelidadeService
      .validarPinCodeEmailValidarCampo(this.membro, pinCode)
      .subscribe(
        (sucesso) => {
          if (sucesso.resultado == true) {
            this.fidelidadeService.obterMembro().subscribe(
              (sucesso: Membro) => {
                sucesso.emailValidado = true;
                sucesso.email = this.membroForm.value.email;
                sucesso.senha = null;
                sucesso.telefone = '55' + this.membroForm.value.telefone;

                this.fidelidadeService
                  .atualizarMembroValidaDados(
                    sucesso,
                    sucesso.email ?? sucesso.cpf
                  )
                  .subscribe(
                    (sucesso) => {
                      this.setarVisibilidadeModalValidacaoDados(false);
                      this.authService.LocalStorage.salvarMembro(sucesso);
                      this.processarSucessoAtualizarMembro(sucesso);
                    },
                    (falha) => {
                      this.processarFalhaAtualizarMembro(falha);
                    }
                  );
              },
              (falha) => {
                this.processarFalhaObterMembro(falha);
              }
            );
          } else {
            alerts.exibirToast('error', 'Código informado inválido!');
            return;
          }

          this.salvandoMembro = false;
        },
        (falha) => {
          this.salvandoMembro = false;
        }
      );
  }

  private obterSmsRequestModel(): SmsRequestModel {
    var smsRequestModel: SmsRequestModel = new SmsRequestModel();

    var messages: MessageRequetModel[] = [
      {
        to: '55' + this.membroForm.value.telefone.toString(),
        body: '',
      },
    ];

    smsRequestModel.messages = messages;

    return smsRequestModel;
  }

  private processarSucessoEnvioSms(response: any) {
    this.iniciarContagemRegressiva();
  }

  private processarFalhaEnvioSms(response: any) {
    this.descricaoModalGenerico =
      'Não foi possível enviar o sms, por favor, verificar o número de telefone cadastrado.';
  }

  private processarSucessoEnvioEmail(response: any) {
    this.iniciarContagemRegressiva();
  }

  private processarFalhaEnvioEmail(response: any) {
    this.descricaoModalGenerico =
      'Não foi possível enviar o codigo, por favor, verificar o e-mail cadastrado.';
  }

  private iniciarContagemRegressiva() {
    this.limparCamposModalGenerico();

    this.time = 300;
    this.interval = setInterval(() => {
      if (this.time === 0) {
        clearInterval(this.interval);
        this.descricaoSegundosModalValidacaoDados = 'Código expirado!';
        this.setarVisibilidadeBotaoReenviar(false);
      } else {
        this.time--;
        this.descricaoSegundosModalValidacaoDados =
          '<img class="opcao__icone icone_timer" src="assets/images/icons/timer.png"/> ' +
          this.time +
          's';
        this.setarVisibilidadeBotaoReenviar(true);
      }
    }, 1000);
  }

  private limparCamposModalGenerico(): void {
    for (let index = 0; index < this.tamanhoInputValidacao.length; index++) {
      const id = 'input_validacao_dados_' + index;
      let input = <HTMLInputElement>document.getElementById(id);
      if (input !== null) input.value = '';
    }
  }

  private setarVisibilidadeBotaoReenviar(show: boolean) {
    this.exibirBotaoReenviar = show;
  }

  private setarVisibilidadeModalValidacaoDados(show: boolean) {
    this.exibirModalValidacaoDados = show;
  }

  private processarSucessoAtualizarMembro(result: any) {
    this.fidelidadeService.obterMembro().subscribe(
      (sucesso) => {
        this.tituloModalGenerico = 'Uouuuuu';
        this.descricaoModalGenerico = 'Dados atualizado com sucesso! :)';
        this.descricaoBotaoModalGenerico = 'Fechar';

        this.exibirPopupGenerico = true;
        this.salvandoMembro = false;
        this.dadosvalidados =
          (sucesso.telefoneValidado ||
            sucesso.emailValidado ||
            (!sucesso.emailValidado && !this.emailEObrigatorio(sucesso))) &&
          this.dataNascimentoValida(sucesso);
        this.authService.LocalStorage.salvarDadosValidados(this.dadosvalidados);
        this.processarSucessoObterMembro(sucesso);
      },
      (falha) => {
        this.processarFalhaObterMembro(falha);
      }
    );
  }

  dataNascimentoValida(membro: any) {
    const dataNascimentoMinima = new Date(1753, 0, 1, 0, 0, 0);

    const nascimento: string = membro.dataNascimento;
    const ano = Number(nascimento.substring(0, 4));
    const mes = Number(nascimento.substring(5, 7));
    const dia = Number(nascimento.substring(8, 10));

    var dataFinal = `${ano}/${mes}/${dia}`;

    const nascimentoDate: Date = new Date(dataFinal);

    if (dataNascimentoMinima.toISOString() == nascimentoDate.toISOString())
      return false;
    else return true;
  }

  emailEObrigatorio(membro: any) {
    const nascimento: string = membro.dataNascimento;
    const ano = Number(nascimento.substring(0, 4));
    const mes = Number(nascimento.substring(5, 7));
    const dia = Number(nascimento.substring(8, 10));

    var dataFinal = `${ano}/${mes}/${dia}`;

    const nascimentoDate: Date = new Date(dataFinal);

    let age = this.getAge(nascimentoDate);

    if (age >= 65) return false;
    else return true;
  }

  getAge(birthDate: Date) {
    var today = new Date();
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  private processarFalhaAtualizarMembro(err: any) {
    this.tituloModalGenerico = 'Atenção :(';
    this.descricaoModalGenerico = err;
    this.descricaoBotaoModalGenerico = 'Fechar';

    this.exibirPopupGenerico = true;
    this.salvandoMembro = false;
  }

  exibirPopupValidacaoDados(campoValidacao: string) {
    this.membro.senha = null;
    this.membro.senhaConfirmacao = null;

    if (campoValidacao == this.CAMPO_TELEFONE) {
      this.telefone = this.membroForm.value.telefone;
      this.validarEmailOuTelefoneDisponivel(campoValidacao);
    }

    if (campoValidacao == this.CAMPO_EMAIL) {
      this.email = this.membroForm.value.email;
      this.validarEmailOuTelefoneDisponivel(campoValidacao);
    }
  }

  handeOtpChange(value: string[]): void {
    console.log(value);
  }

  validarCodigo(campoValidacao: string, otp: any) {

    let pinCode: string = otp;

    if (pinCode?.length < 6) return;

    if (campoValidacao == this.CAMPO_TELEFONE) this.validarSms(pinCode);
    else if (campoValidacao == this.CAMPO_EMAIL) this.validarEmail(pinCode);
  }

  cancelar() {
    this.authService.LocalStorage.desconectar();
    this.router.navigate(['/']);
  }

  private formarDataNascimentoParaDate(data: Date) {
    var dataToString = data.toString();

    const dia = parseInt(dataToString.substring(0, 2));
    const mes = parseInt(dataToString.substring(2, 4)) - 1;
    const ano = parseInt(dataToString.substring(4));

    return new Date(ano, mes, dia);
  }

  validaDataNasc() {
    let membro = this.membroForm.value;
    const nascimento: string = membro.dataNascimento;
    const ano = Number(nascimento.substring(4, 8));

    if (ano.toString().length < 4) {
      alerts.exibirToast('waning', 'Informe uma data de nascimento válida');
      return;
    }

    const idade = new Date().getFullYear() - ano;

    this.idadeMembro = idade;

    if (idade > 120) {
      alerts.exibirToast('warning', 'Informe uma data de nascimento válida');
    } else if (idade < 16) {
      alerts.exibirToast(
        'info',
        'Somente maiores de 16 anos podem cadastrar-se! Leia o regulamento.'
      );
    }

    const dia = Number(nascimento.substring(0, 2));
    const mes = Number(nascimento.substring(2, 4));
    const anoData = Number(nascimento.substring(4, 8));

    let dataFinal = `${anoData}/${mes}/${dia}`;

    const nascimentoDate: Date = new Date(dataFinal);

    this.fidelidadeService.obterMembro().subscribe(
      (res: Membro) => {
        res.senha = null;
        res.dataNascimento = nascimentoDate;

        this.fidelidadeService
          .atualizarMembroValidaDados(res, res.email ?? res.cpf)
          .subscribe(
            (res) => {
              this.authService.LocalStorage.salvarMembro(res);
              this.processarSucessoAtualizarMembro(res);
            },
            (err) => {
              this.processarFalhaAtualizarMembro(err);
            }
          );
      },
      (err) => {
        this.processarFalhaObterMembro(err);
      }
    );
  }

  dadosValidadosSucesso() {
    var linkRedirect =
      this.authService.LocalStorage.obterRedirectLink().replace(/['"]+/g, '');

    if (linkRedirect != '') this.router.navigateByUrl(linkRedirect);
    else this.router.navigate(['/index']);
  }
}
